import { DateTime } from 'luxon';

const WAITING_ROOM_QUERY_KEY = 'waitingRoomQuery';
const defaultQueryDate = () => DateTime.now().toUTC().minus({ hours: 1 });

const clearWaitingRoomQuery = () => localStorage.removeItem(WAITING_ROOM_QUERY_KEY);

const setWaitingRoomQuery = (queuedSince: DateTime | undefined) => {
  localStorage.setItem(
    WAITING_ROOM_QUERY_KEY,
    JSON.stringify({
      queuedSince: (queuedSince ?? defaultQueryDate()).toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'"),
    }),
  );
};

const getWaitingRoomQuery = (): { queuedSince: string } => {
  let storedQuery = localStorage.getItem(WAITING_ROOM_QUERY_KEY);
  if (!storedQuery) {
    setWaitingRoomQuery(undefined);
    storedQuery = localStorage.getItem(WAITING_ROOM_QUERY_KEY);
  }
  return JSON.parse(storedQuery ?? '');
};

export const TelecomService = {
  clearWaitingRoomQuery,
  setWaitingRoomQuery,
  getWaitingRoomQuery,
};
